import { changeSaveStatus } from 'actions/signUpFlow';

export const handleAsyncValidate = async (form, dispatch) => {
  dispatch(changeSaveStatus.notSaved());
};
